import { getAxiosInstance } from '../blocks/axios/axiosFactory';
import { SearchCouponsRequest } from '../models/tariff/SearchCouponsRequest';

const url = "/tariff";

export default class TariffService {
    static searchCoupons(request: SearchCouponsRequest) {
        return getAxiosInstance().post(`${url}/searchCoupons`, { ...request });
    }

    static getTrafficAreas() {
        return getAxiosInstance().get(`${url}/getTrafficAreas`);
    }
}
